import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 20,
	viewBox: "0 0 100 20",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 10,
			r: 5,
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "cy",
				values: "10;5;10",
				dur: "0.6s",
				repeatCount: "indefinite"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 10,
			r: 5,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "cy",
				values: "10;5;10",
				dur: "0.6s",
				repeatCount: "indefinite",
				begin: "0.2s"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 80,
			cy: 10,
			r: 5,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "cy",
				values: "10;5;10",
				dur: "0.6s",
				repeatCount: "indefinite",
				begin: "0.4s"
			})
		})
	]
});
export default SvgLoadingDots;
